import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd'

export default {
  name: 'confirm-line-haul-connection',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading
  },
  data: function() {
    return {
      stoppointforemail: '',
      showemailpage: false,
      emailIdErrorMSG: "",
      mailId: "",
      isLoading: false,
      showTable: true,
      lineHaulObjData: {
        coloadername: "",
        routemode: "",
        vehiclename: "",
        vehicleno: "",
        awbno: "",
        pcs: "",
        totalphysicalweight: "",
        totalvolumetricweight: "",
        boggieno: "",
        breakno: "",
        traintype: "",
        rrno: "",
        rrno1: "",
        rrno2: "",
        departuredate: "",
        departuretime: "",
        scheduledate: "",
        arrivaldate: "",
        arrivaltime: "",
        printDate: "", //
        printBy: "", //
        connectionname: "",
        departuredate: "",
        departuretime: "",
        noofbags: "",
      },
      lineHaulShipmentObjData: [{
        bagtype: "",
        bagno: "",
        parentBags: "",
        totalShipments: "",
        destinationhubid: "",
        physicalweight: "]",
        volumetricweight: ""
      }],
      printDate: '',
      printBy: '',
      isDisplay: true,
      tripid: '',
      tripdata: {},
      tripdatafound: false,
      currenthubid: '',
      currenthub: '',
      connectionschedulemasterid: '',
      shipmentdata: [],
      vendortype: '',
      emailIdValidationMSG: '',
      fullConnectionName: '',
      touchpointlist:[],
      touchpointitem:{value:'',text:''},
      touchpointname:'',
      regForMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/


    }
  },
  created: function() {},
  model: {
    totalVolWt: 0,
    totalPhyWt: 0,
    totalLineHaulBags: 0,
    totalBags: 0,
    totalShipments: 0
  },
  computed: {
    TotalVolWt: function() {
      return this.lineHaulShipmentObjData.reduce(function(totalVolWt, item) {
        return totalVolWt + parseFloat(item.volumetricweight);
      }, 0);
    },
    TotalPhyWt: function() {
      return this.lineHaulShipmentObjData.reduce(function(totalPhyWt, item) {
        return totalPhyWt + parseFloat(item.volumetricweight);
      }, 0);
    },
    TotalLineHaulBags: function() {
      return this.lineHaulShipmentObjData.length
    },
    TotalBags: function() {
      return 0;
      // return this.lineHaulShipmentObjData.reduce(function(totalBags, item) {
      // 	return totalBags + parseFloat(item.volumetricweight);
      // }, 0);
    },
    TotalShipments: function() {
      return this.lineHaulShipmentObjData.reduce(function(totalShipments, item) {
        return totalShipments + parseFloat(item.totalshipments);
      }, 0);
    }
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    momentDate: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    },
    momentTime: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('HH:mm:ss');
    },
    toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
      // var with2Decimals = val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      // return  with2Decimals
    },
    jsUcfirst: function(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getDestination: function(name) {
      if (name == null || name == '')
        return '--'
      var destinationname = name.split("(")
      return destinationname[0]
    },
    getHubDetails(arr) {
      if (arr.length < 1) {
        return '';
      }

      var input = {
        hubids: [arr[(arr.length) - 1].HubID]
      }
      return axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "expose/hubservicecenter/hubarray/get",
          'data': input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          return result.data.ResponseData[0].HubName
        }, error => {
          console.error(error)
        })
    },
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;
    this.printDate = moment().format('DD-MM-YYYY');
    this.printBy = userdetail[0].email;
    this.tripid = this.$route.params.tripid;
    this.currenthubid = this.$route.params.currenthubid;
    this.connectionschedulemasterid = this.$route.params.connectionschedulemasterid;
    this.connectionid = this.$route.params.connectionid;
    this.getTripDetails();
  },
  methods: {
    resetForm() {
      this.mailId = '',
        this.emailIdErrorMSG = '',
        this.emailIdValidationMSG = ''
    },
    SendMailFunction() {
      this.emailIdValidationMSG = ''
      this.emailIdErrorMSG = ''
      if (this.mailId == '' || this.mailId == undefined) {
        this.emailIdErrorMSG = "Enter Email-Id"
        return false
      }
      var mailArray = [];
      mailArray = this.mailId.split(',');
      for (var i = 0; i < mailArray.length; i++) {
        if (this.regForMail.test(mailArray[i]) == false) {
          this.emailIdValidationMSG = "Invalid MailId" + " " + mailArray[i]
          return false
        }
      }
      this.input = {
        "ConnectionScheduleMasterID": Number(this.connectionschedulemasterid),
        "CurrentHubId": Number(this.currenthubid),
        "TouchPointHubId": this.stoppointforemail,
        "VendorVehicleTripID": Number(this.tripid),
        "To": this.mailId
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'emailNetworkPrealert_v1',
          'data': this.input,
          headers: {
            'Authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          var response = result.data
          // console.log(response);
          if (response.ResultCode == 100) {
            this.$alertify.success(response.ReturnMessage)
            this.stoppointforemail = ''
            this.closeSendMailPage()
            this.resetForm()
          } else {
            this.$alertify.error(response.ReturnMessage)
          }
          this.isLoading = false
        }, error => {
          this.isLoading = false
          console.error(error)
        })
    },
    closeSendMailPage() {
      this.showemailpage = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
      this.resetForm();
    },
    sendMail() {
      this.showemailpage = true;
    },
    // selectedTouchPoint(touchpointitem){
    //   this.touchpointitem = touchpointitem
    //   this.touchpointname = touchpointitem.text
    //   if(this.touchpointname!=''){
    //     var stoppointarr= []
    //     stoppointarr.push(this.touchpointitem.value)
    //     this.getshipmentdata(stoppointarr, this.currenthubid, this.connectionschedulemasterid);
    //   }
    // },
    getTripDetails() {
      this.tripdata = {};
      this.shipmentdata = {};
      this.isLoading = true;
      this.tripdatafound = false;
      this.input = {
        "VendorVehicleTripID": parseInt(this.tripid)
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'GetNetworkTripDetails',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoading = false
          if (result.data.ResultCode == 100) {
            var response = result.data.ResponseData[0];
            var tripdata = response;
            this.tripdata = response;
            if (this.tripdata.TripType == 'MarketHired') {
              this.vendortype = 'Market'
            } else if (this.tripdata.TripType == 'VendorBased' || this.tripdata.TripType == 'NetworkBased' || this.tripdata.TripType == 'Network') {
              this.vendortype = 'Attached'
            } else {
              this.vendortype = ''
            }
            var stoppointarr = [];
            if (tripdata.Connectiondetails.length > 0) {
              var stoppoints = tripdata.Connectiondetails[0].Stoppoints
              for (var i = 0; i < stoppoints.length; i++) {
                stoppointarr.push(stoppoints[i].StopPointHubId);
                // this.touchpointlist.push({
                //   value:stoppoints[i].StopPointHubId,
                //   text:stoppoints[i].StopPointName,
                // });
              }
              this.stoppointforemail = stoppointarr.toString();

            }
            this.getshipmentdata(stoppointarr, this.currenthubid, this.connectionschedulemasterid);

            var arr = tripdata.ShipmentDetails
            if (arr.length > 0) {
              var input = {
                hubids: [arr[(arr.length) - 1].HubID]
              }
              return axios({
                  method: 'POST',
                  'url': apiUrl.api_url_hubops + "expose/hubservicecenter/hubarray/get",
                  'data': input,
                  headers: {
                    'authorization': 'authkey xB84JJ89Hd25',
                  }
                })
                .then(result => {
                  this.currenthub = result.data.ResponseData[0].HubName
                  this.tripdata = tripdata
                }, error => {
                  console.error(error)
                })

            }

          } else {
            this.$alertify.error("No record found")
          }
        }, error => {
          this.isDisplay = false
          this.isLoading = false
          console.error(error)
        })

    },
    getshipmentdata(stoppoints, currenthubid, connectionschedulemasterid) {
      this.shipmentdata = []
      this.fullConnectionName = ''
      this.isLoading = true
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getBulkShipmentsFromParticularTouchPoint_v1?ConnectionScheduleMasterID=' + connectionschedulemasterid + '&CurrentHubId=' + currenthubid + '&TouchPointHubId=' + stoppoints.join(','),
          // 'url': "http://huboperation-apistage.xbees.in/api/getShipmentsFromTouchPoints?ConnectionScheduleMasterID=" + connectionschedulemasterid + "&CurrentHubId=" + currenthubid + "&TouchPointHubId=" + stoppoints.join(','),
          headers: {
            'Authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          var shdata = [];
          this.isLoading = false
          if (result.data.ResultCode == 100) {
            this.isLoading = false;
            this.tripdatafound = true;
            this.shipmentdata = result.data.ResponseData;
            this.fullConnectionName = result.data.fullConnectionName;
          } else {
            this.isLoading = false;
            this.shipmentdata = [];
            this.fullConnectionName = '';
            this.tripdatafound = false;
            this.$alertify.error("No record found")
          }

          // for(var z in shipmentcounttinfodata.ResponseData){
          //    shdata.push()
          // }
          //  console.log(result.data.data[0]);
        }, error => {
          this.isDisplay = false
          this.isLoading = false
          this.isLoading = false
          console.error(error)
        })
    },
    gettotalshipments(d) {
      var totalShipments = 0;
      for (var i = 0; i < d.length; i++) {
        totalShipments = totalShipments + parseInt(d[i].shipmentcount)
      }
      return totalShipments;
    },
    gettotalphywt(d) {
      var totalphywt = 0;
      for (var i = 0; i < d.length; i++) {
        totalphywt = totalphywt + parseFloat(d[i].physicalweight)
      }
      return totalphywt;
    },
    gettotalcharwt(d) {
      var totalcharwt = 0;
      for (var i = 0; i < d.length; i++) {
        totalcharwt = totalcharwt + parseFloat(d[i].chargeableweight)
      }
      return totalcharwt;
    },
    gettotalvolwt(d) {
      var totalvorwt = 0;
      for (var i = 0; i < d.length; i++) {
        totalvorwt = totalvorwt + parseFloat(d[i].volumetricweight)
      }
      return totalvorwt;
    },
    printLineHaul() {
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
					@media print {
  				h3 {
    			page-break-after: always;
  				}
					}
          @media print {
               .noprint {
                  visibility: hidden;
               }
            }
          `
      d.print(document.getElementById('tripsheetContent'), cssText);
    },
    toFixedVal(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/components/TripSheetPrintForBulkFromCurrentTPV1/TripSheetPrintForBulkFromCurrentTPV1.js